var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordHide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Show Password/14x14") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "7.10542736e-15 0 11.7522495 0 11.7522495 11.3056 7.10542736e-15 11.3056"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Show-Password/14x14",
    stroke: "none",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.742,6.5097 C3.717,6.3697 3.704,6.2257 3.704,6.0787 C3.704,4.7447 4.785,3.6637 6.119,3.6637 C6.266,3.6637 6.41,3.6767 6.55,3.7017 C6.604,3.7117 6.66,3.6957 6.698,3.6567 L7.954,2.4007 C8.039,2.3157 8.004,2.1707 7.888,2.1387 C7.329,1.9827 6.735,1.8927 6.119,1.8927 C4.433,1.8927 2.917,2.5697 1.824,3.4077 C1.277,3.8277 0.828,4.2937 0.513,4.7477 C0.204,5.1927 0,5.6607 0,6.0787 C0,6.4967 0.204,6.9647 0.513,7.4097 C0.782,7.7967 1.148,8.1937 1.59,8.5617 C1.653,8.6147 1.746,8.6097 1.804,8.5517 L3.697,6.6577 C3.736,6.6197 3.752,6.5637 3.742,6.5097",
    id: "Fill-10",
    fill: "current"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(2.248351, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6332495,8.0856 C5.1532495,8.0856 4.7072495,7.9416 4.3312495,7.6996 L5.0412495,6.9896 C5.2222495,7.0716 5.4222495,7.1196 5.6332495,7.1196 C6.4332495,7.1196 7.0822495,6.4706 7.0822495,5.6706 C7.0822495,5.4586 7.0342495,5.2596 6.9522495,5.0786 L7.6622495,4.3686 C7.9042495,4.7446 8.0482495,5.1896 8.0482495,5.6706 C8.0482495,7.0046 6.9672495,8.0856 5.6332495,8.0856 M11.2392495,4.3396 C10.9242495,3.8856 10.4752495,3.4196 9.9282495,2.9996 C9.7622495,2.8716 9.5852495,2.7496 9.4002495,2.6306 L11.1522495,0.8786 C11.3532495,0.6776 11.3532495,0.3516 11.1522495,0.1506 C10.9502495,-0.0504 10.6242495,-0.0504 10.4232495,0.1506 L0.148249496,10.4266 C0.0432494959,10.5316 -0.00375050407,10.6696 0.000249495928,10.8066 C-0.00375050407,10.9356 0.0402494959,11.0656 0.139249496,11.1646 C0.237249496,11.2626 0.367249496,11.3076 0.496249496,11.3026 C0.502249496,11.3026 0.507249496,11.3056 0.512249496,11.3056 C0.644249496,11.3056 0.776249496,11.2556 0.877249496,11.1556 L2.8092495,9.2226 C3.6502495,9.6066 4.6102495,9.8566 5.6332495,9.8566 C7.3192495,9.8566 8.8352495,9.1796 9.9282495,8.3406 C10.4752495,7.9216 10.9242495,7.4546 11.2392495,7.0016 C11.5482495,6.5556 11.7522495,6.0876 11.7522495,5.6706 C11.7522495,5.2526 11.5482495,4.7846 11.2392495,4.3396",
    id: "Fill-12",
    fill: "current"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordHide);
export default __webpack_public_path__ + "static/media/password_hide.86db77739ed8e0a25b19d20a25cd99b2.svg";
export { ForwardRef as ReactComponent };